<template>
  <div
    class="ui-h-xs ui-w-xs ui-rounded-round ui-border-md ui-border-t-mkm-yellow-dark ui-border-mkm-blue-light motion-safe:ui-animate-loading"
  />
</template>
